module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Question-circle-e56f895e62bba167520fe560c6dca4a7.svg";